var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"12"}},[_c('small',[_vm._v("Die Felder mit einem * sind Pflichtfelder und müssen ausgefüllt werden")])])}
var staticRenderFns = []

export { render, staticRenderFns }